// TODO Rename endpoints to use operationId from swagger

export const TRADE = {
  LIST: 'trade/list',
  PROXY_BID_CREATE: 'trade/upcoming-proxy-bidding/create'
};

export const BID = {
  CREATE: 'bid/create'
};

export const USER = {
  LIST: 'user/list',
  DETAILS: 'user/details'
};

export const RESEARCH = {
  GRAPH: 'research/graph'
};

export const MEDIA = {
  LIST: 'media/list',
  MANAGE_METADATA: 'media/manage/metadata'
};

export const POSTSALE = {
  GET_SHIPPING_ESTIMATE: 'post-sale/shipping/estimate',
  GET_SHIPPING_TERM_AND_CONDITIONS:
    'post-sale/shipping/rate-info/terms-and-conditions'
};

export const CHAT = {
  LIST: 'chat/list'
};

export const WATCHLIST = {
  ADD: 'list/add/watchlist',
  REMOVE: 'list/remove/watchlist'
};

export const IMPOUND = {
  ADD: 'list/add/impound',
  REMOVE: 'list/remove/impound'
};

export const AUTH = {
  REFRESH: '/auth/refresh'
};

export const FEATURE_FLAG = {
  RETRIEVE_ALL: '/feature-flag'
};
